export function embedYoutubeVideos(text) {
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/g;
  let youtube_id;
  let youtube_url;
  const content = text.replace(youtubeRegex, (match, videoId) => {
    youtube_url = match
    youtube_id = videoId
    return `<lite-youtube videoid="${videoId}" playlabel="Play"></lite-youtube>`;
  });

  return { content, youtube_id, youtube_url };
}



export function observeEmbeds() {
  const embeds = document.querySelectorAll("lite-youtube");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // If the element is not in the viewport
      if (!entry.isIntersecting) {
        // Remove the iframe containing the YouTube player
        const iframe = entry.target.querySelector("iframe");
        entry.target.classList.remove("lyt-activated");
        // entry.target.classList.remove("in-view");
        if (iframe) {
          iframe.remove();
        }
      }
      // else {
      //   entry.target.classList.add("in-view");
      // }
    });
  });
  // Start observing the lite-youtube elements
  embeds.forEach((el) => observer.observe(el));
}



export function intersectionObserver(fetchFn)  {
  return new IntersectionObserver(entries => {
  if (entries[0].intersectionRatio <= 0) return
    fetchFn()
  });
}


export function unescapeHTML(html) {
  var text = document.createElement('textarea');
  text.innerHTML = html;
  return text.value;
}


export function replaceLiteYouTubeWithURL(htmlString) {
  const liteYoutubeRegex = /<lite-youtube\s+videoid="([^"]+)"\s+playlabel="([^"]+)">[^<]*<\/lite-youtube>/g;

  return htmlString.replace(liteYoutubeRegex, (match, videoId) => {
    return `https://www.youtube.com/watch?v=${videoId}`;
  });
}
